<template>
  <div class="pokedex-info">
    <h1>图鉴说明</h1>
    <p>此处可填写图鉴说明、使用方法或筛选条件等信息。</p>
  </div>
</template>

<script>
export default {
  name: "PokedexInfo",
};
</script>

<style scoped>
.pokedex-info {
  padding: 20px;
}
</style>
